// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveOutlinedSvg from "@fishx/icons-svg/es/asn/SaveOutlined";
import FishxIcon from '../components/FishxIcon';

var SaveOutlined = function SaveOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveOutlinedSvg
  }));
};

SaveOutlined.displayName = 'SaveOutlined';
export default React.forwardRef(SaveOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SaveOutlined.js
// module id = 4055
// module chunks = 0